import { format } from 'date-fns';
import { instance } from '../../config/intercepter';

// todo: check if there i=any post method
export const getUsersFn = async () => {
  const response = await instance.get('api/users');
  return response.data;
};

export const getUsersListFn = async ({ queryKey }) => {
  const [
    ,
    { length = '25', orderType = 'asc', orderBy = 'id', search = '', page = 1 },
  ] = queryKey;
  const response = await instance.get(
    `api/users?length=${length}&orderType=${orderType}&orderBy=${orderBy}&search=${search}&page=${page}`
  );
  return response.data;
};

// todo: check if it is get or post
export const getUserFormFn = async () => {
  const response = await instance.get('api/users/create');
  return response.data;
};

export const getUserByIdFn = async (user) => {
  const response = await instance.get(`api/users/${user}`);
  return response.data;
};

export const addUserFn = async (payload) => {
  const response = await instance.post(`api/users`, payload);
  return response.data;
};

// todo: put or patch
export const updateUserByIdFn = async (userId, payload) => {
  const response = await instance.put(`api/users/${userId}`, payload);
  return response.data;
};

export const deleteUserByIdFn = async (userId) => {
  const response = await instance.delete(`api/users/${userId}`);
  return response.data;
};

// todo check  updateUserByIdFn required or not
export const editUserByIdFn = async (userId) => {
  const response = await instance.get(`api/users/${userId}/edit`);
  return response.data;
};

// roles
export const getRolesFn = async () => {
  const response = await instance.get(`api/roles`);
  return response.data;
};

export const getRoleByIdFn = async (id) => {
  const response = await instance.get(`api/roles/${id}`);
  return response.data;
};

export const addRoleByIdFn = async (payload) => {
  const response = await instance.post(`api/roles`, payload);
  return response.data;
};

export const updateRoleByIdFn = async (payload) => {
  const response = await instance.put(`api/roles/${payload.id}`, payload);
  return response.data;
};

export const deleteRoleByIdFn = async (payload) => {
  const response = await instance.delete(`api/roles/${payload.id}`, payload);
  return response.data;
};

export const assignRoleFn = async (userId, roleId) => {
  const response = await instance.post(`api/roles/${userId}/assign/${roleId}`);
  return response.data;
};

export const removeRoleFn = async (userId, roleId) => {
  const response = await instance.delete(
    `api/roles/${userId}/remove/${roleId}`
  );
  return response.data;
};

export const syncRoleFn = async (userId) => {
  const response = await instance.post(`api/roles/${userId}/sync`);
  return response.data;
};

// offer
export const impersonateUserFn = async ({ queryKey }) => {
  const [_key, { id, afm, username }] = queryKey;
  const response = await instance.get(
    `api/impersonate/${id}/${afm}/${username}`
  );
  return response.data;
};

export const uploadUserFn = async (payload) => {
  const response = await instance.post(`api/importusers`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const getBookingListFn = async ({ queryKey }) => {
  const [
    _key,
    {
      length = '100',
      orderType = 'asc',
      orderBy = 'id',
      search = '',
      page = 1,
    },
  ] = queryKey;
  const response = await instance.get(
    `api/bookingreports?length=${length}&orderType=${orderType}&orderBy=${orderBy}&search=${search}&page=${page}`
  );
  return response.data;
};

export const getBookingStatisticsFn = async (id) => {
  const response = await instance.get(`api/bookingstatistics`);
  return response.data;
};

export const getAllOfferReportingsFn = async ({
  length = '-1',
  orderType = '',
  orderBy = '',
  search = '',
  page = 1,
}) => {
  const response = await instance.get(
    `api/reportingstats?length=${length}&orderType=${orderType}&orderBy=${orderBy}&search=${search}&page=${page}`
  );
  return response.data;
};

export const getOfferReportingListFn = async ({ queryKey }) => {
  const [
    _key,
    { length = '100', orderType = '', orderBy = '', search = '', page = 1 },
  ] = queryKey;
  const response = await instance.get(
    `api/reportingstats?length=${length}&orderType=${orderType}&orderBy=${orderBy}&search=${search}&page=${page}`
  );
  return response.data;
};

export const downloadLogsFn = async ({ queryKey }) => {
  const [
    _key,
    { length = '25', orderType = '', orderBy = 'id', search = '', page = 1 },
    { downloadFrom, downloadTo, invoicesFrom, invoicesTo },
  ] = queryKey;
  let url = `api/downloadlogs?length=${length}&orderType=${orderType}&orderBy=${orderBy}&search=${search}&page=${page}`;

  if (downloadFrom) {
    url = `${url}&downloadFrom=${format(downloadFrom, 'yyy-MM-dd HH:mm:ss')}`;
  }
  if (downloadTo) {
    url = `${url}&downloadTo=${format(downloadTo, 'yyy-MM-dd HH:mm:ss')}`;
  }
  if (invoicesFrom) {
    url = `${url}&invoicesFrom=${format(invoicesFrom, 'yyy-MM-dd HH:mm:ss')}`;
  }
  if (invoicesTo) {
    url = `${url}&invoicesTo=${format(invoicesTo, 'yyy-MM-dd HH:mm:ss')}`;
  }

  const response = await instance.get(url);
  return response.data;
};
